export default __webpack_public_path__ + "static/media/about_us_background.1959cb35.jpeg";